var variant_inventory_default = (() => {
    if (customElements.get("variant-inventory")) return;
    const RED = "var(--red-tone-900)";
    const ORANGE = "var(--red-tone-300)";
    customElements.define("variant-inventory", class VariantInventory extends HTMLElement {
        connectedCallback() {
            this.target = this.querySelector("[data-inventory]");
            this.dot = this.querySelector("[data-inventory-dot]");
            this.text = this.querySelector("[data-inventory-text]");
            this.productId = this.dataset.productId ? +this.dataset.productId : null;
            this.lowRed = +this.dataset.lowStockRed || Infinity;
            this.lowOrange = +this.dataset.lowStockOrange || Infinity;
            this.inModal = !!this.closest(".ajax-modal");
            document.addEventListener("variant:change", this.onChange);
        }
        disconnectedCallback() {
            document.removeEventListener("variant:change", this.onChange);
        }
        onChange=event => {
            if (!!event.detail.modal !== this.inModal) return;
            if (this.productId !== null && event.detail.productId !== this.productId) return;
            this.render(event.detail.variant);
        };
        isTracked(variant) {
            return variant && variant.inventory_management === "shopify" && variant.inventory_policy === "deny";
        }
        itemsLeft(count) {
            const templates = window.MBF?.strings?.inventory?.itemsLeft;
            if (!templates) return "";
            const tpl = count === 1 ? templates.one : templates.other;
            return tpl ? tpl.replace("__count__", count) : "";
        }
        render(variant) {
            if (!this.target) return;
            let show = false;
            let color = "";
            let label = "";
            if (variant && !variant.available) {
                show = true;
                color = RED;
                label = window.MBF?.strings?.soldOut || "";
            } else if (this.isTracked(variant) && variant.inventory_quantity > 0) {
                const qty = variant.inventory_quantity;
                if (qty <= this.lowRed) {
                    show = true;
                    color = RED;
                    label = this.itemsLeft(qty);
                } else if (qty <= this.lowOrange) {
                    show = true;
                    color = ORANGE;
                    label = this.itemsLeft(qty);
                }
            }
            this.target.classList.toggle("hidden", !show);
            if (this.dot) if (color) this.dot.style.backgroundColor = color; else this.dot.style.backgroundColor = "";
            if (this.text) this.text.textContent = label;
        }
    });
})();